import RecruitingInterviewSheet from './sheets/RecruitingInterviewSheet';
import MultipleChoiceExamSheet from './sheets/MultipleChoiceExamSheet';
import ExamDetailSkeleton from '../../components/ExamDetailSkeleton';
import CodingExamSheet from './sheets/CodingExamSheet';
import ExamTabs from '../../components/ExamTabs';
import { useExamDetail } from '../../hooks/useExamDetail';
import MotionWrapper from '../../../../../layouts/MotionWrapper';
import { useNavigate } from 'react-router-dom';
import styles from './style.module.scss';

export default function ExamSheet() {
    const navigate = useNavigate();
    const {
        tab,
        tabs,
        jobInfo,
        fetching,
        changeTab,
        codingExam,
        multipleChoiceExam,
        recruitingInterview,
    } = useExamDetail();

    const renderSheet = () => {
        if (fetching) return <ExamDetailSkeleton />;

        switch (tab) {
            case 'recruitingInterview':
                return <RecruitingInterviewSheet examData={recruitingInterview} />;
            case 'multipleChoice':
                return <MultipleChoiceExamSheet examData={multipleChoiceExam} />;
            case 'coding':
                return <CodingExamSheet jobTitle={jobInfo?.title || ''} examData={codingExam} />;
            default:
                return null;
        }
    };

    return (
        <MotionWrapper className={styles.container}>
            <span className={styles.backToList} onClick={() => navigate(-1)}>
                Back to exam statistics
            </span>

            <div className={styles.main}>
                <div className={styles.main_header}>
                    <span className={styles.main_header_title}>Exam sheets</span>
                </div>

                <ExamTabs tabs={tabs} activeTab={tab} onChange={changeTab} />

                <div className={styles.main_table}>
                    {renderSheet()}
                </div>
            </div>
        </MotionWrapper>
    );
};
